var map = {
	"./1893/01_no.svg": "9715",
	"./1893/01_sub_no.svg": "af18",
	"./1893/01_sub_uk.svg": "f68b",
	"./1893/01_uk.svg": "dd16",
	"./1893/02_no.svg": "75cb",
	"./1893/02_sub_no.svg": "0a54",
	"./1893/02_sub_uk.svg": "f1d5",
	"./1893/02_uk.svg": "c436",
	"./1893/03_no.svg": "768b",
	"./1893/03_sub_no.svg": "7eba",
	"./1893/03_sub_uk.svg": "e406",
	"./1893/03_uk.svg": "dffe",
	"./1893/04_no.svg": "ae9c",
	"./1893/04_sub_no.svg": "08b4",
	"./1893/04_sub_uk.svg": "5627",
	"./1893/04_uk.svg": "2cb9",
	"./1893/05_no.svg": "66cb",
	"./1893/05_sub_no.svg": "2c79",
	"./1893/05_sub_uk.svg": "d8e4",
	"./1893/05_uk.svg": "98c9",
	"./1893/06_no.svg": "ac19",
	"./1893/06_sub_no.svg": "6929",
	"./1893/06_sub_uk.svg": "627e",
	"./1893/06_uk.svg": "0325",
	"./1893/07_no.svg": "3e15",
	"./1893/07_sub_no.svg": "308a",
	"./1893/07_sub_uk.svg": "1436",
	"./1893/07_uk.svg": "6b10",
	"./1893/08_no.svg": "543d",
	"./1893/08_sub_no.svg": "50cf",
	"./1893/08_sub_uk.svg": "1813",
	"./1893/08_uk.svg": "78c9",
	"./1893/intro_no.svg": "82e4",
	"./1893/intro_sub_no.svg": "763d",
	"./1893/intro_sub_uk.svg": "310c",
	"./1893/intro_uk.svg": "8b22",
	"./1893/title_no.svg": "9bda",
	"./1893/title_uk.svg": "d716",
	"./1925/01_no.svg": "26e3",
	"./1925/01_sub_no.svg": "4078",
	"./1925/01_sub_uk.svg": "f7ae",
	"./1925/01_uk.svg": "a2ac",
	"./1925/02_no.svg": "9dd4",
	"./1925/02_sub_no.svg": "600e",
	"./1925/02_sub_uk.svg": "8377",
	"./1925/02_uk.svg": "a436",
	"./1925/03_no.svg": "9eee",
	"./1925/03_sub_no.svg": "47c5",
	"./1925/03_sub_uk.svg": "294d",
	"./1925/03_uk.svg": "3513",
	"./1925/04_no.svg": "dd06",
	"./1925/04_sub_no.svg": "9b62",
	"./1925/04_sub_uk.svg": "b3ac",
	"./1925/04_uk.svg": "ba66",
	"./1925/05_no.svg": "ee5d",
	"./1925/05_sub_no.svg": "ed29",
	"./1925/05_sub_uk.svg": "0284",
	"./1925/05_uk.svg": "5cf2",
	"./1925/06_no.svg": "3e9d",
	"./1925/06_sub_no.svg": "1a38",
	"./1925/06_sub_uk.svg": "bea6",
	"./1925/06_uk.svg": "d53d",
	"./1925/intro_no.svg": "1223",
	"./1925/intro_sub_no.svg": "f89b",
	"./1925/intro_sub_uk.svg": "b60b",
	"./1925/intro_uk.svg": "9d40",
	"./1925/title_no.svg": "07f3",
	"./1925/title_uk.svg": "0790",
	"./1949/01_no.svg": "5ae9",
	"./1949/01_sub_no.svg": "1123",
	"./1949/01_sub_uk.svg": "fce5",
	"./1949/01_uk.svg": "095f",
	"./1949/02_no.svg": "2524",
	"./1949/02_sub_no.svg": "bf64",
	"./1949/02_sub_uk.svg": "026f",
	"./1949/02_uk.svg": "433e",
	"./1949/03_no.svg": "07e0",
	"./1949/03_sub_no.svg": "d871",
	"./1949/03_sub_uk.svg": "d4bb",
	"./1949/03_uk.svg": "e50f",
	"./1949/04_no.svg": "90c4",
	"./1949/04_sub_no.svg": "dfe2",
	"./1949/04_sub_uk.svg": "9f1c",
	"./1949/04_uk.svg": "1ec3",
	"./1949/Group 121.svg": "ea8a",
	"./1949/intro_no.svg": "e3ef",
	"./1949/intro_sub_no.svg": "b479",
	"./1949/intro_sub_uk.svg": "c8f2",
	"./1949/intro_uk.svg": "2aa8",
	"./1949/title_no.svg": "1373",
	"./1949/title_uk.svg": "55a9",
	"./1951/01_no.svg": "eb8d",
	"./1951/01_sub_no.svg": "1eb2",
	"./1951/01_sub_uk.svg": "39f6",
	"./1951/01_uk.svg": "ffa0",
	"./1951/02_no.svg": "636f",
	"./1951/02_sub_no.svg": "a69d",
	"./1951/02_sub_uk.svg": "63e5",
	"./1951/02_uk.svg": "eac7",
	"./1951/03_no.svg": "579b",
	"./1951/03_sub_no.svg": "b342",
	"./1951/03_sub_uk.svg": "025c",
	"./1951/03_uk.svg": "d920",
	"./1951/intro_no.svg": "08f2",
	"./1951/intro_sub_no.svg": "4ed3",
	"./1951/intro_sub_uk.svg": "b470",
	"./1951/intro_uk.svg": "a543",
	"./1951/title_no.svg": "c943",
	"./1951/title_uk.svg": "8ca4",
	"./1956/01_no.svg": "7446",
	"./1956/01_sub_no.svg": "2a40",
	"./1956/01_sub_uk.svg": "0443",
	"./1956/01_uk.svg": "0d86",
	"./1956/02_no.svg": "edf5",
	"./1956/02_sub_no.svg": "c4f1",
	"./1956/02_sub_uk.svg": "b982",
	"./1956/02_uk.svg": "f78d",
	"./1956/03_no.svg": "98c6",
	"./1956/03_sub_no.svg": "fdf4",
	"./1956/03_sub_uk.svg": "3115",
	"./1956/03_uk.svg": "38c3",
	"./1956/intro_no.svg": "3789",
	"./1956/intro_sub_no.svg": "f8cd",
	"./1956/intro_sub_uk.svg": "a47d",
	"./1956/intro_uk.svg": "e37a",
	"./1956/title_no.svg": "7796",
	"./1956/title_uk.svg": "2ddb",
	"./1960/01_no.svg": "5c4b",
	"./1960/01_sub_no.svg": "bd89",
	"./1960/01_sub_uk.svg": "a15f",
	"./1960/01_uk.svg": "ed09",
	"./1960/02_no.svg": "dbd7",
	"./1960/02_sub_no.svg": "df80",
	"./1960/02_sub_uk.svg": "9014",
	"./1960/02_uk.svg": "ca96",
	"./1960/03_no.svg": "c469",
	"./1960/03_sub_no.svg": "76cc",
	"./1960/03_sub_uk.svg": "b10f",
	"./1960/03_uk.svg": "f36a",
	"./1960/04_no.svg": "ac44",
	"./1960/04_sub_no.svg": "29d3",
	"./1960/04_sub_uk.svg": "b754",
	"./1960/04_uk.svg": "d844",
	"./1960/intro_no.svg": "1288",
	"./1960/intro_sub_no.svg": "ec05",
	"./1960/intro_sub_uk.svg": "a879",
	"./1960/intro_uk.svg": "38a1",
	"./1960/title_no.svg": "8eee",
	"./1960/title_uk.svg": "b2d8",
	"./1982/01_no.svg": "c7b6",
	"./1982/01_sub_no.svg": "e398",
	"./1982/01_sub_uk.svg": "b80e",
	"./1982/01_uk.svg": "001c",
	"./1982/02_no.svg": "ae74",
	"./1982/02_sub_no.svg": "672d",
	"./1982/02_sub_uk.svg": "9139",
	"./1982/02_uk.svg": "56b9",
	"./1982/03_no.svg": "e46f",
	"./1982/03_sub_no.svg": "73f5",
	"./1982/03_sub_uk.svg": "f1d8",
	"./1982/03_uk.svg": "588a",
	"./1982/intro_no.svg": "2707",
	"./1982/intro_sub_no.svg": "61e8",
	"./1982/intro_sub_uk.svg": "307b",
	"./1982/intro_uk.svg": "51cb",
	"./1982/title_no.svg": "b841",
	"./1982/title_uk.svg": "ca23",
	"./1993/01_no.svg": "f18f",
	"./1993/01_sub_no.svg": "69cd",
	"./1993/01_sub_uk.svg": "d905",
	"./1993/01_uk.svg": "505b",
	"./1993/02_no.svg": "3a44",
	"./1993/02_sub_no.svg": "82c3",
	"./1993/02_sub_uk.svg": "c4e1",
	"./1993/02_uk.svg": "0080",
	"./1993/03_no.svg": "e334",
	"./1993/03_sub_no.svg": "715a",
	"./1993/03_sub_uk.svg": "8221",
	"./1993/03_uk.svg": "8339",
	"./1993/04_no.svg": "daba",
	"./1993/04_sub_no.svg": "b2e9",
	"./1993/04_sub_uk.svg": "8d2c",
	"./1993/04_uk.svg": "a00e",
	"./1993/05_no.svg": "f4ec",
	"./1993/05_sub_no.svg": "f30c",
	"./1993/05_sub_uk.svg": "b089",
	"./1993/05_uk.svg": "880e",
	"./1993/06_no.svg": "87d5",
	"./1993/06_sub_no.svg": "7343",
	"./1993/06_sub_uk.svg": "5107",
	"./1993/06_uk.svg": "377d",
	"./1993/07_no.svg": "a1a7",
	"./1993/07_sub_no.svg": "dca0",
	"./1993/07_sub_uk.svg": "964b",
	"./1993/07_uk.svg": "bb41",
	"./1993/08_no.svg": "b1d5",
	"./1993/08_sub_no.svg": "3a2c",
	"./1993/08_sub_uk.svg": "86a1",
	"./1993/08_uk.svg": "2e86",
	"./1993/09_no.svg": "1edc",
	"./1993/09_sub_no.svg": "e7e7",
	"./1993/09_sub_uk.svg": "738e",
	"./1993/09_uk.svg": "58d2",
	"./1993/intro_no.svg": "e2e7",
	"./1993/intro_sub_no.svg": "97e0",
	"./1993/intro_sub_uk.svg": "19eb",
	"./1993/intro_uk.svg": "245c",
	"./1993/title_no.svg": "fdd0",
	"./1993/title_uk.svg": "5cd6",
	"./2016/01_no.svg": "6828",
	"./2016/01_sub_no.svg": "7e60",
	"./2016/01_sub_uk.svg": "2430",
	"./2016/01_uk.svg": "8864",
	"./2016/02_no.svg": "0784",
	"./2016/02_sub_no.svg": "f9b8",
	"./2016/02_sub_uk.svg": "aa65",
	"./2016/02_uk.svg": "3980",
	"./2016/03_no.svg": "2bd5",
	"./2016/03_sub_no.svg": "38b3",
	"./2016/03_sub_uk.svg": "fc8a",
	"./2016/03_uk.svg": "d6b0",
	"./2016/04_no.svg": "28c2",
	"./2016/04_sub_no.svg": "f399",
	"./2016/04_sub_uk.svg": "d318",
	"./2016/04_uk.svg": "4f58",
	"./2016/05_no.svg": "e3fd",
	"./2016/05_sub_no.svg": "ccca",
	"./2016/05_sub_uk.svg": "7eb4",
	"./2016/05_uk.svg": "f6de",
	"./2016/intro_no.svg": "426d",
	"./2016/intro_sub_no.svg": "13d2",
	"./2016/intro_sub_uk.svg": "af17",
	"./2016/intro_uk.svg": "c7d5",
	"./2016/title_no.svg": "8164",
	"./2016/title_uk.svg": "492e",
	"./gui/BT_language_NO.svg": "9ae5",
	"./gui/BT_language_UK.svg": "a4d6",
	"./gui/arrow_backward.svg": "03be",
	"./gui/arrow_forward.svg": "ffb3",
	"./gui/button_down.svg": "8552",
	"./gui/button_home.svg": "810c",
	"./gui/button_language_no.svg": "6913",
	"./gui/button_up.svg": "442f",
	"./gui/close.svg": "7f06",
	"./main/1893_no.svg": "c5b4",
	"./main/1893_uk.svg": "ac79",
	"./main/1925_no.svg": "a73b",
	"./main/1925_uk.svg": "a1d2",
	"./main/1949_no.svg": "121e",
	"./main/1949_uk.svg": "bde3",
	"./main/1951_no.svg": "4a8d",
	"./main/1951_uk.svg": "2986",
	"./main/1956_no.svg": "0b95",
	"./main/1956_uk.svg": "99c6",
	"./main/1960_no.svg": "2aa3",
	"./main/1960_uk.svg": "cd34",
	"./main/1982_no.svg": "360b",
	"./main/1982_uk.svg": "6711",
	"./main/1993_no.svg": "b36a",
	"./main/1993_uk.svg": "4ee8",
	"./main/2016_no.svg": "8114",
	"./main/2016_uk.svg": "0864",
	"./main/button_language_no.svg": "681c",
	"./main/button_language_uk.svg": "9de9",
	"./main/intro text_no.svg": "c549",
	"./main/intro text_uk.svg": "9973"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "edbe";